import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { numberFormat } from 'helper';
import moment from 'moment';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import TransactionRow from 'modules/common/components/TransactionRow';
import _ from 'lodash';
import * as actions from '../action';
import * as c from '../constant';

function SupersededAssessmentTab({
  showSupersededAssessmentLogs,
  getSupersededAssessmentLogs,
  historyInfo,
  dataList,
  isLoading,
}) {

  const OnSetFormData = () => {
    if (!_.isEmpty(_.get(dataList, '0.id'))) {
      const id = _.get(dataList, '0.id');
      showSupersededAssessmentLogs(historyInfo, id);
    }
  };

  useEffect(() => {
    if (_.isEmpty(historyInfo)) return;
    getSupersededAssessmentLogs(historyInfo.id);
  }, []);
  useEffect(() => {
    if (_.isEmpty(historyInfo)) return;
    getSupersededAssessmentLogs(historyInfo.id);
  }, [historyInfo]);

  useEffect(() => {
    if (dataList.length > 0) {
      OnSetFormData();
    }
  }, [dataList]);

  useEffect(() => {
    if (dataList.length > 0) {
      OnSetFormData();
    }
  }, []);

  return (
    <>
      <div className="p-3 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            {_.isEmpty(dataList) ? (
              <div className="d-flex align-items-center justify-content-center h-100">
                <div className="text-center mx-auto py-4">
                  <img
                    src={emptyStateImage}
                    className="img-responsive image-wrapper mb-4 mt-3"
                    alt="Empty State"
                  />
                  <p className="emp-title mb-0"> No Item Found </p>
                </div>
              </div>
            ) : (
              dataList.map((item) => {
                return (
                  <React.Fragment key={item.id}>
                    <div className="col-12 mt-3">
                      <table className="transaction-table table table-borderless table-sm table-striped">
                        <tbody>
                          <TransactionRow
                            title="PIN"
                            value={_.get(item, 'attributes.pin') || '--'}
                          />
                          <TransactionRow
                            title="TDN No."
                            value={_.get(item, 'attributes.td_no') || '--'}
                          />
                          <TransactionRow
                            title="Previous Owner"
                            value={_.get(item, 'attributes.previous_owner') ||
                              '--'}
                          />
                          <TransactionRow
                            title="AR Page No."
                            value={_.get(item, 'attributes.ar_page_no') || '--'}
                          />
                          <TransactionRow
                            title="ARP No."
                            value={_.get(item, 'attributes.arp_no') || '--'}
                          />
                          <TransactionRow
                            title="Total Assessed Value"
                            value={numberFormat(
                              _.get(
                                item,
                                'attributes.total_assessed_value'
                              ),
                              2
                            ) || '--'}
                          />
                          <TransactionRow
                            title="Effectivity of Assessment"
                            value={_.get(item,
                              'attributes.effectivity_of_assessment')
                              ? moment(
                                `${_.get(
                                  item,
                                  'attributes.effectivity_of_assessment'
                                )}`
                              ).format('YYYY')
                              : '--'}
                          />
                        </tbody>
                      </table>
                    </div>
                    <hr className='below-table' style={{ marginTop: 10, marginLeft: 250 }} />
                    <div className="col-12 mt-3">
                      <table className="transaction-table table table-borderless table-sm table-striped">
                        <tbody>
                          <TransactionRow
                            title="Recording Person"
                            value={_.get(item, 'attributes.recording_person') ||
                              '--'}
                          />
                          <TransactionRow
                            title="Date"
                            value={_.get(item, 'attributes.date')
                              ? moment(
                                `${_.get(
                                  item, 'attributes.date'
                                )}`
                              ).format('MM/DD/YYYY HH:mm a')
                              : '--'}
                          />
                        </tbody>
                      </table>
                    </div>
                  </React.Fragment>
                );
              })
            )}
          </>
        )}
      </div>
    </>
  );
}
SupersededAssessmentTab.defaultProps = {
  historyInfo: {},
};

SupersededAssessmentTab.propTypes = {
  showSupersededAssessmentLogs: PropTypes.instanceOf(Function).isRequired,
  getSupersededAssessmentLogs: PropTypes.instanceOf(Function).isRequired,
  historyInfo: PropTypes.instanceOf(Object),
  dataList: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  dataList: _.get(api, `${c.GET_SUPERSEDED_ASSESSMENT_LOGS}.list`) || [],
  dataInfo:
    _.get(api, `${c.SHOW_SUPERSED_ASSESSMENT_LOGS}.item`) || {},
  isLoading:
    _.get(api, 'loading', []).indexOf(c.GET_SUPERSEDED_ASSESSMENT_LOGS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(SupersededAssessmentTab);
